import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import { Ifilter, FilterOperators } from '../../../components/common/filters/interfaces';
import { SERVICES, HttpMethods, ContentTypes, HttpError } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { fetchAccountsList } from '../../accounts/list.thunks';
import { showSuccessMessage, showErrorMessage } from '../../notifications';
import { ThunkAPI } from '../../rootReducer';
import { ListParams } from '../../utils';
import { IAddProSeatsDTO, IAddProSeatsDTOWithoutCustomerId, IAddProSeatsResponse } from './interfaces';

export const addProSeats: AsyncThunk<IAddProSeatsResponse, IAddProSeatsDTO, ThunkAPI> = createAsyncThunk(
  'add_pro_seats',
  async (data: IAddProSeatsDTO, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<IAddProSeatsResponse, IAddProSeatsDTOWithoutCustomerId>({
        endpoint: `customer/${data.customerId}/subscription/updateSeats`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: ContentTypes.ApplicationJson
      })({
        seatsToAdd: data.seatsToAdd,
        prorationDate: data.prorationDate
      }, thunk);
      thunk.dispatch(showSuccessMessage('Payment Successful!'));
      const fetchAccountsRequest: ListParams<Ifilter[]> = {
        filters: [
          {
            field: '_id',
            operands: [data.customerId],
            operator: FilterOperators.isAnyOf,
            validateInputs: false
          }
        ],
        pagination: { offset: 0, limit: 25 }
      };
      thunk.dispatch(fetchAccountsList(fetchAccountsRequest));
      thunk.dispatch(push({
        pathname: '/settings/users', state: {
          openAddUsersModal: true,
          successMessage: 'Payment Successful!'
        }
      }));
      return response;
    } catch (err) {
      let errorMessage = 'An error occurred while adding seats';
      if (err instanceof Error || err instanceof HttpError) {
        errorMessage = err.message || errorMessage;
      }
      thunk.dispatch(showErrorMessage(errorMessage));
      return thunk.rejectWithValue(errorMessage);
    }
  }
);

export const previewAddProSeats: AsyncThunk<IAddProSeatsResponse, IAddProSeatsDTO, ThunkAPI> = createAsyncThunk(
  'preview_add_pro_seats',
  async (data: IAddProSeatsDTO, thunk) => {
    try {
      return await basicApiAsyncThunkCreator<IAddProSeatsResponse, IAddProSeatsDTOWithoutCustomerId>({
        endpoint: `customer/${data.customerId}/subscription/previewUpdateSeats`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: ContentTypes.ApplicationJson
      })({
        seatsToAdd: data.seatsToAdd,
        prorationDate: data.prorationDate
      }, thunk);
    } catch (err) {
      let errorMessage = 'An error occurred while previewing updated seats';
      if (err instanceof Error || err instanceof HttpError) {
        errorMessage = err.message || errorMessage;
      }
      thunk.dispatch(showErrorMessage(errorMessage));
      return thunk.rejectWithValue(errorMessage);
    }
  }
);